<div class="fMap">
    <app-floor-map></app-floor-map>
</div>